module.exports = __webpack_public_path__ + "static/img/lipei.107e4b02.jpg";